import { Box, Chip, Container, Grid, Typography } from "@mui/material"
import { useApiGet } from "auth/useApi2"
import Button from "components/Button"
import ClpTable from "components/ClpTable"
import {
  DatePickerColumnFilter,
  MultiSelectFilter,
  SelectColumnFilter
} from "components/ClpTable/ClpTableFilterTypes"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import moment from "moment"
import { useContext, useEffect, useMemo } from "react"
import { Link, useHistory } from "react-router-dom"
import { StyledTableContainer } from "shared/styled/Global"
import { useTranslation } from "react-i18next"

const NewsAdmin = () => {
  const routerHistory = useHistory()
  const [getNewsResult, getNews] = useApiGet()
  const loadingContext = useContext(GlobalLoaderContext)
  const { t } = useTranslation("translation")

  useEffect(() => {
    getNews(apiEndpoints.newsadmin.listarticles)
  }, [getNews])

  useEffect(() => {
    loadingContext.setLoading(() => getNewsResult.status === 1)
  })

  const columns = useMemo(
    () => [
      {
        accessorKey: "subject",
        header: t("news.heading", "Subject")
      },
      {
        accessorFn: (row) => {
          return row.publishedDate ? moment(row.publishedDate).format("YYYY-MM-DD hh:mm") : ""
        },
        header: t("global.created", "Created"),
        meta: {
          filter: DatePickerColumnFilter
        }
      },
      {
        accessorKey: "publishedByUser.name",
        header: t("global.created_by", "Created by")
      },
      {
        accessorFn: (row) => {
          return row.priorityEndDate ? moment(row.priorityEndDate).format("YYYY-MM-DD hh:mm") : ""
        },
        header: t("news.priority_date", "Priority date")
      },
      {
        accessorFn: (row) => {
          return row.priorityEndDate && moment().isSameOrBefore(row.priorityEndDate) ? "yes" : "no"
        },
        header: t("news.prioritized", "Prioritized"),
        filterFn: "arrIncludesSome",
        meta: {
          filter: MultiSelectFilter,
          filterOptions: [
            {
              name: t("global.important", "Important"),
              value: "yes"
            },
            {
              name: t("news.not_important", "Not important"),
              value: "no"
            }
          ],
          mainFilter: true
        },
        cell: ({ cell }) => {
          const isPriority =
            cell.row.original.priorityEndDate && moment().isSameOrBefore(cell.row.original.priorityEndDate)
          return isPriority ? (
            <Box display="flex" justifyContent={{ xl: "flex-start", lg: "flex-end" }}>
              <Chip color="primary" label={t("global.important", "Important")} />
            </Box>
          ) : null
        }
      }
    ],
    []
  )

  return (
    <div>
      <Container>
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h1">{t("news.administer_news", "Administer news")}</Typography>
            <Button
              sx={{ mt: { xs: 2, sm: 0 } }}
              component={Link}
              color="primary"
              to={allRoutes.NewsAdminAdd()}>
              {t("news.new_news_article", "New news article")}
            </Button>
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          rows={getNewsResult.status === 2 && getNewsResult.data}
          loadingState={getNewsResult.status}
          columns={columns}
          onRowClick={(row) => routerHistory.push(allRoutes.NewsAdminEdit(row.original.id))}
        />
      </StyledTableContainer>
    </div>
  )
}

export default NewsAdmin
